import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { Observable } from 'rxjs/Observable';
import { UserProfile } from '../../core/model/user-profile.model';
import * as auth from '../../core/actions/logout.actions';
import { selectUserProfile } from '../../app.selector';

/**
 * Component displays application header.
 */
@Component({
    selector: 'ssf-app-header',
    template: require('./app-header.component.html'),
    styles: [require('./app-header.component.scss')]
})
export class AppHeaderComponent {
    @Output() logout = new EventEmitter<any>();
    userProfile$: Observable<UserProfile>;
    public i18n = 'APP.';

    constructor(private store: Store<AppState>) {
        this.userProfile$ = this.store.select(selectUserProfile);
    }

    doLogout() {
        this.logout.emit(null);

        // logout causes redirect so we need some time for the animations to run
        setTimeout(() => {
            this.store.dispatch(new auth.LogoutAction());
        }, 500);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/app-header/app-header.component.ts